var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBungalows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2890_166235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.182 11.804L13.064 13.582L15.682 12.154V19H18.034V9.48H16.312L12.182 11.804Z",
    fill: "#00166F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8606 22.3482L22.9238 21.1256L24.6147 16.6584L27.062 17.4578L25.8606 22.3482ZM28.9308 12.2852L21.8559 12.9435L18.4297 24.3702L28.8863 27.0506L32.0011 16.4703L28.9308 12.2852Z",
    fill: "#F6931E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91568 18.1634L5.73769 13.7902L9.11941 13.6021L9.16391 17.9283L5.91568 18.1634ZM18.3746 8.3825L9.11941 3.53906L2 11.439L4.22481 25.8283L11.7447 25.0289L11.4777 17.5991L15.3489 17.0349L15.8828 24.6527L18.8196 24.3235L18.3746 8.3825Z",
    fill: "#037F45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2890_166235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBungalows);
export default __webpack_public_path__ + "static/media/bungalows.1dc4af666de96ca650710151db09ffc2.svg";
export { ForwardRef as ReactComponent };